import { BaseWebComponentDataProvider } from '../../../../../framework/BaseWebComponentDataProvider';
import { MspInProductTrialsAdditionalUserSettings } from '../view/configs/msp-in-product-trials-overlay-window-config';

export abstract class MspInProductTrialsOverlayWindowsAppBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getAdditionalUserSettingsForMspInProductTrials(): Promise<MspInProductTrialsAdditionalUserSettings>;
}
